<app-custom-index></app-custom-index>
<div class="row">
  <div class="col-lg-12">
    <div class="col-lg-12">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <h3 class="mb-0">CSS Files</h3>
          </div>
        </div>
        <!-- Light table -->
        <div class="table-responsive">
          <table class="table align-items-center table-flush table-hover">
            <!-- <thead>
                    <tr>
                        <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                    </tr>
                </thead> -->
            <thead class="thead-light">
              <tr>
                <th> File Name</th>
                <th> Regex</th>
                <th> Description</th>
                <th> Url</th>
                <th> Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of customCssFiles">
                <td>{{item.fileName}}</td>
                <td> {{ item.urlRegex}}</td>
                <td> {{ item.description}}</td>
                <td> {{ item.fileurl}}</td>
                <td>
                  <span><a [href]="getSafeUrl(item.fileurl)" download><i
                        class="fas fa-download mr-2 handCusor"></i></a></span>
                  <span><i class="fas fa-trash handCusor text-danger" (click)="popCssFileDelete(item)"></i></span>
                </td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="customCssFiles.length<=0" class="text-center">No File Available</p>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" #uploadCSSFile id="uploadCSSFile" aria-hidden="true" aria-labelledby="uploadCSSFile"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upload CSS File</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #uploadform="ngForm" name="uploadform" (submit)="uploadCssFile()">
          <div class="">
            <div class="row">
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label">URL Regex</label>
                  <input type="text" class="form-control" placeholder="^.*$" [(ngModel)]="customCss.URLRegex"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label">Description</label>
                  <input type="text" class="form-control" [(ngModel)]="customCss.Description"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-6">
                <div class="mb-3">
                  <label for="formFile" class="form-label">CSS File</label>
                  <input class="form-control" type="file" id="formFile" required accept=".css"
                    [(ngModel)]="customCss.File" [ngModelOptions]="{standalone: true}"
                    (change)="onFileSelected($event)">
                </div>
              </div>

              <!-- <div class="col-6">
                <div class="mb-3">
                  <label class="form-label">File Name</label>
                  <input type="text" class="form-control" [(ngModel)]="customCss.FileName"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </div> -->
            </div>

          </div>

          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0">Upload</button>
            <button type="button" class="btn btn--warning m-0" data-dismiss="modal">Close</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteCssFile" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete File</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this File? <b>{{fileToDelete.fileName}}</b></p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteFile()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="uploadImgFile" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upload Image Files</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <input type="file" multiple (change)="onImageFileChange($event)" accept="image/*">
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="uploadImgs()">Upload</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewImgs" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Image Files</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">

        <div class="card">

          <!-- Light table -->
          <div class="table-responsive">
            <table class="table align-items-center table-flush table-hover">
              <!-- <thead>
                      <tr>
                          <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                      </tr>
                  </thead> -->
              <thead class="thead-light">
                <tr>
                  <th> File Name</th>
                  <th> Url</th>
                  <th> Preview</th>
                  <th> Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of customlayoutImages">
                  <td>{{item.fileName}}</td>
                  <td> {{ item.safeUrl}}</td>
                  <td><img [src]="getSafeUrl(item.safeUrl)" alt="" width="80px" height="80px" /></td>
                  <td>
                    <span><a [href]="getSafeUrl(item.safeUrl)" download target="_blank"><i
                          class="fas fa-download mr-2 handCusor"></i></a></span>
                    <span><i class="fas fa-trash handCusor text-danger" (click)="popImageDelete(item)"></i></span>
                  </td>
                </tr>
              </tbody>
            </table>
            <p *ngIf="customlayoutImages.length<=0" class="text-center">No Image Available</p>

          </div>
        </div>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <!-- <button type="submit" class="btn btn--danger m-0" (click)="uploadImgs()">Upload</button> -->
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="deleteImg" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Image</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this Image? <b>{{imageToDelete.fileName}}</b></p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteImg()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
